import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGroups } from '../../../store/actions/groupsActions';
import { saveDashboard, fetchDashboardById } from "../../../store/actions/dashsActions";
import TitlePage from '../../../components/general/TitlePage/TitlePage';
import Input from '../../../components/general/Input/Input';
import TitleSectionComponent from '../../../components/intern/TitleSectionComponent/TitleSectionComponent';
import CheckBoxContainer from '../../../components/general/CheckBox/CheckBoxContainer';
import Button from '../../../components/general/Button/Button';
import AlertComponent from '../../../components/intern/Alert/Alert';

import './UserSearchList.css'

const CriarDashboardPage = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { groups, loading, error } = useSelector((state) => state.groups);
    const [dashboardName, setDashboardName] = useState("");
    const [dashboardDescription, setDescription] = useState("");
    const [datoramaUrl, setDatoramaUrl] = useState("");
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [urlError, setUrlError] = useState("");
    const [nameError, setNameError] = useState("");
    const [descriptionError, setDescriptionError] = useState("");
    const [alertType, setAlertType] = useState("");
    const [alert, setAlert] = useState(null);
    const alertTimeoutId = useRef(null);

    useEffect(() => {
        return () => {
            if (alertTimeoutId.current) clearTimeout(alertTimeoutId.current);
        };
    }, []);

    const navigate = useNavigate();
    useEffect(() => {
        dispatch(fetchGroups());
    }, [dispatch]);

    const handleNameDashChange = (e) => {
        const value = e.target.value;
        setDashboardName(value);

        if (value.length < 3) {
            setNameError("O nome deve conter pelo menos 3 caracteres para facilitar a identificação.");
        } else {
            setNameError("");
        }
    };

    const handleDescriptionChange = (e) => {
        const value = e.target.value;

        if (value.length <= 200) {
            setDescription(value);
        }

        if (value.length > 200) {
            setDescriptionError("A descrição não pode exceder 200 caracteres.");
        } else {
            setDescriptionError("");
        }
    };

    const showAlert = (type, message) => {
        // Limpa timeout anterior
        if (alertTimeoutId.current) {
            clearTimeout(alertTimeoutId.current);
        }
        setAlert({ type, message });

        alertTimeoutId.current = setTimeout(() => {
            setAlert(null);
            alertTimeoutId.current = null;
        }, 5000);
    };

    const handleUrlChange = (e) => {
        const url = e.target.value;
        setDatoramaUrl(url);
        setUrlError(validateUrl(url) ? "" : "Insira uma URL válida (ex: https://exemplo.com).");
    };

    const validateUrl = (url) => {
        return /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,7}(\/[^\s]*)?$/.test(url);
    };

    const handleGroupSelection = (selectedGroups) => {
        setSelectedGroups(selectedGroups);
    };

    const descriptionToSave = dashboardDescription.substring(0, 200);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Verificando se os campos obrigatórios estão preenchidos
        if (nameError || urlError || !dashboardName || !datoramaUrl) {
            showAlert("excluir", "Preencha todos os campos obrigatórios corretamente!");
            return;
        }

        try {
            let response;
            response = await dispatch(
                saveDashboard({ dashboardName, dashboardDescription: descriptionToSave, datoramaUrl, selectedGroups })
            ).unwrap();
            console.log("Dashboard salvo com sucesso!", response);
            showAlert('adicionar', 'Dashboard criado com sucesso!');
            navigate("/dashboard");

        } catch (error) {
            console.error("Falha ao salvar: verifique os campos obrigatórios e tente novamente.", error);
        }
    };

    if (loading) return <p>Carregando sistema... Por favor, aguarde.</p>;
    if (error) return <p>Erro: {error}</p>;

    return (
        <section className="container-extern content-with-sidebar">

            <TitlePage
                title="Novo Dashboard"
                subtitle="Configure um novo dashboard e defina as permissões de acesso de forma segura e organizada."
            />
            <Helmet>
                <title>New Dashboard</title>
            </Helmet>

            <form onSubmit={handleSubmit}>
                <Input
                    type="text"
                    placeholder="Nome do dashboard..."
                    value={dashboardName}
                    onChange={handleNameDashChange}
                    label="Nome:"
                    errorMessage={nameError}
                />

                <Input
                    type="text"
                    placeholder="Descrição do dashboard..."
                    value={dashboardDescription}
                    onChange={handleDescriptionChange}
                    label="Descrição: "
                    maxLength={200}
                    errorMessage={descriptionError}
                />
                {!descriptionError && (
                    <p className='description-maxlenght'>
                        {dashboardDescription.length}/200 caracteres
                    </p>
                )}

                <Input
                    type="url"
                    placeholder="URL do Datorama..."
                    value={datoramaUrl}
                    onChange={handleUrlChange}
                    label="URL do Datorama:"
                    errorMessage={urlError}
                />

                <TitleSectionComponent>Incluir dashboard em grupos existentes:</TitleSectionComponent>
                <CheckBoxContainer
                    options={groups.map(group => ({ label: group.groupName, value: group.uid }))}
                    onChange={handleGroupSelection}
                    initialValues={selectedGroups}
                />

                <div className='section-btn-page'>
                    <Button
                        type="submit"
                        variant="add"
                        className='btn-add'
                        disabled={!!nameError || !!urlError || !dashboardName || !datoramaUrl}
                    >
                        Criar Dashboard
                    </Button>
                </div>
                {alert && <AlertComponent type={alert.type} onClose={() => setAlert(null)} />}


            </form>
        </section>
    );
};

export default CriarDashboardPage;
